import React, { FC } from 'react';
import { Arrows, Carousel, Slide, Track } from '@fiverr-private/carousel';
import { translate } from '@fiverr-private/i18n-react';
import { Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { RelatedGuidesData } from '../../types';
import { Guide } from './Guide';
import { SeeMoreLink } from './SeeMoreLink';

export interface RelatedGuidesProps {
  title?: string;
  seeMoreText?: string | number;
  seeMoreLink?: string;
  guides?: RelatedGuidesData;
  sourcePageKey?: string;
  titleClassName?: string;
}

export const RelatedGuides: FC<RelatedGuidesProps> = ({
  title = '',
  seeMoreText = '',
  seeMoreLink,
  guides,
  sourcePageKey = '',
  titleClassName = '',
}) => {
  if (!guides || !guides.items || guides.items.length < 3) {
    return null;
  }

  return (
    <Stack as="section" gap="0" wrap="wrap" position="relative" width="100%">
      <Typography className={titleClassName} as="h2" marginRight="auto" color="grey_1100">
        {title || translate('seo_content.related_guides.title')}
      </Typography>
      <Stack
        width="100%"
        marginTop="8"
        wrap="wrap"
        direction={{
          default: 'column',
          sm: 'row',
        }}
        order={{
          md: 3,
        }}
        paddingBottom={{
          sm: '0',
        }}
      >
        <Carousel
          breakpoints={{
            default: 1,
            sm: 2,
            md: 3,
          }}
          scrollType="single"
        >
          <Arrows />
          <Track>
            {guides.items.map((el, index) => (
              <Slide key={el.guideTitle}>
                <Guide
                  title={el.guideTitle}
                  articleLink={el.guideUrl}
                  imageLink={el.imageUrl}
                  imageAlt={el.imageAlt}
                  index={index}
                  sourcePageKey={sourcePageKey}
                />
              </Slide>
            ))}
          </Track>
        </Carousel>
      </Stack>
      <SeeMoreLink text={seeMoreText} link={seeMoreLink} sourcePageKey={sourcePageKey} alignSelf="flexEnd" />
    </Stack>
  );
};
